module.exports = __webpack_public_path__ + "static/media/runoncloud.b75ce71c.svg";